{
  "on": "on",
  "none": "No",
  "device": "devices | device | devices",
  "operation": "operations | operation | operations",
  "profile": "profiles | profile | profiles",
  "application": "applications | application | applications",
  "campaign": "campaigns | campaign | campaigns",
  "user": "users | user | users",
  "group": "groups | group | groups",
  "userGroup": "user groups | user group | user groups",
  "firmware": "firmware | firmware | firmware",
  "applicationMgt": "applications | application | applications",
  "dtwins": "devices | device | devices"
}
